import type { remoteOption } from '@code-expert/prelude';
import type { TaskId } from '/imports/domain';
import { useCachedQuery } from '/imports/ui/hooks/useProcedure';
import type { QuizPageInfo } from './QuizPageInfo';

export interface QuizApi {
  usePageInfo: (taskId: TaskId) => remoteOption.RemoteOption<QuizPageInfo>;
  useTaskName: (taskId: TaskId) => remoteOption.RemoteOption<string>;
}

export const quizApi: QuizApi = {
  usePageInfo: (taskId) => useCachedQuery('quizzes.getPageInfo', { props: taskId })[0],

  useTaskName: (taskId) => useCachedQuery('tasks_getTaskName', { props: taskId })[0],
};
